// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grecaptcha-badge{visibility:hidden}.dev-info{border:1px dashed #000;border-radius:10px;margin-top:50px;opacity:.5;padding:10px}.dev-info:before{content:\"DEV/STAGE ONLY\";display:block;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
